"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRowApi = void 0;
var table_cell_collection_1 = require("../collections/table/table-cell-collection");
var interval_1 = require("../interval");
var TableRowApi = (function () {
    function TableRowApi(processor, tablePosition) {
        this._tablePosition = tablePosition;
        this._processor = processor;
    }
    Object.defineProperty(TableRowApi.prototype, "index", {
        get: function () {
            return this._tablePosition.rowIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableRowApi.prototype, "interval", {
        get: function () {
            return interval_1.convertToIntervalApi(this._tablePosition.row.interval);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableRowApi.prototype, "cells", {
        get: function () {
            return new table_cell_collection_1.TableCellCollection(this._processor, this._tablePosition.clone());
        },
        enumerable: false,
        configurable: true
    });
    return TableRowApi;
}());
exports.TableRowApi = TableRowApi;
